export default (isMobile, elem) => (tl) => {
  tl.from(elem, 0.6, { opacity: 0, y: '+=66' }, 0.2)
}



// WEBPACK FOOTER //
// ./src/components/staticAnim.js